import { motion } from 'framer-motion';

export const Zizo = ({ expression = 'happy', size = 'medium', animate = true }) => {
  const sizeMap = {
    small: 'w-16 h-16',
    medium: 'w-24 h-24',
    large: 'w-32 h-32',
    xlarge: 'w-48 h-48'
  };
  
  const emojis = {
    happy: '🦊',
    thinking: '🤔',
    celebrate: '🎉',
    wave: '👋',
    sad: '😢'
  };
  
  return (
    <motion.div
      className={`${sizeMap[size]} flex items-center justify-center text-6xl`}
      animate={animate ? {
        y: [0, -10, 0],
        rotate: [0, 5, -5, 0]
      } : {}}
      transition={{
        duration: 2,
        repeat: Infinity,
        repeatType: 'reverse'
      }}
    >
      {emojis[expression] || emojis.happy}
    </motion.div>
  );
};
